import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

const dayjsExtend = (option, dayjsClass) => {
    dayjsClass.prototype.ceilMinutes = function (amount) {
        const totalMinutes = Math.ceil(this.minute() / amount) * amount;
        return this.set('minutes', totalMinutes).set('seconds', 0).set('millisecond', 0);
    };
};

dayjs.extend(dayjsExtend);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);

const setDayjsLocale = (locale) => {
    dayjs.locale(locale);
    // import(`dayjs/locale/${locale}`).then(() => {
    //     dayjs.locale(locale);
    // });
};

export { dayjs, setDayjsLocale };
